/* eslint-env browser */
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Table from './components/Table';

const rootElement = document.querySelector('.data-table');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(rootElement!);

root.render(
  <StrictMode>
    <Table />
  </StrictMode>,
);
